<template>
    <div id="app">
        <StartView v-if="noCurrentProfile" />
        <KlinikenFrame v-else />
        <ConfirmDialog />
        <Popup />
        <portal-target name="modal" />
    </div>
</template>

<script setup>
    import { useStore } from "@/store";
    import { computed, onBeforeMount, onMounted, watch } from "vue";
    import StartView from "@/components/StartView.vue";
    import KlinikenFrame from "@/components/KlinikenFrame.vue";
    import ConfirmDialog from "@/components/ConfirmDialog.vue";
    import Popup from "@/components/Popup.vue";
    import { PortalTarget } from "portal-vue";

    const store = useStore();
    const noCurrentProfile = computed(() => !store.state.userData.currentProfile);

    onBeforeMount(async () => {
        await store.dispatch("loginMode/setSettings", window.location.pathname);
    });

    onMounted(async () => {
        await store.dispatch("systemData/loadFromBackend", {
            failSilently: true,
        });
    });

    /*
        Används för att sätta last active när användaren loggar in och förhindra att en loggas direkt
        Fix för https://github.com/Datatrion/kliniken3/issues/1879
     */
    watch(
        noCurrentProfile,
        () => {
            store.commit("idle/setLastActive", new Date());
        },
        {
            immediate: true,
        }
    );
</script>

<style lang="scss">
    @import "normalize.css";
    @import "@/style/app";
    @import "@/style/tooltips/klinikentooltip";
</style>
